import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i9.7
import React from 'react';
import IconWrap, { IconSize } from '../../IconWrap';
const DollarSign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({
        size: IconSize.SMALLER
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        id: "path-1",
        d: "M7.053 13.093v-1.266C5.76 11.573 4.88 10.76 4.667 9.493h2.08c.173.507.6.76 1.213.76.56 0 .947-.266.947-.706 0-.414-.254-.574-.8-.707l-1.32-.307c-1.094-.266-1.974-.853-1.974-2.226 0-1.28.894-2.2 2.24-2.427V2.667H8.76V3.92c1.213.28 1.907 1.107 2.107 2.227H8.893c-.173-.4-.533-.694-1.133-.694-.547 0-.907.267-.907.667 0 .36.227.533.64.64l1.454.36c1.306.32 2.013 1.053 2.013 2.293 0 1.32-.907 2.174-2.2 2.427v1.253H7.053z"
    })));
};
DollarSign.displayName = 'DollarSign';
export default DollarSign;
